import { render } from "./Rebuild.vue?vue&type=template&id=00f2f7d3"
import script from "./Rebuild.vue?vue&type=script&lang=js"
export * from "./Rebuild.vue?vue&type=script&lang=js"
script.render = render

export default script